import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDisplayed'
})
export class IsDisplayedPipe implements PipeTransform {

  transform(data: any[]): any[] {
    return data.filter(item => item.isDisplayed === true);
  }

}
